export default __webpack_public_path__ + "static/media/MX.0327b02e.svg";